import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeader from "@/components/base/SectionHeader";
import { faqs } from "@/mocks/melons";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-8 lg:grid-cols-[1fr_1.5fr]">
          <div>
            <SectionHeader
              eyebrow="常见问题"
              eyebrowIcon="ri-question-answer-line"
              title="关于本站，你可能想问"
              desc="围绕更新频率、内容核实、投稿方式与转载规则等常见疑问，我们整理了这份说明，帮助你更安心地围观与参与。"
            />
            <div className="mt-6 hidden rounded-2xl bg-accent-500 p-5 text-background-50 lg:block">
              <p className="font-heading text-xl leading-tight">还有疑问？</p>
              <p className="mt-1.5 text-sm text-accent-50/90">通过底部投稿表单选择「合作建议」，我们会尽快回复。</p>
              <a href="#submit" className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-medium text-accent-700 transition-transform hover:-translate-y-0.5">
                留言咨询 <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <Reveal key={f.q} delay={i * 40}>
                  <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50 shadow-soft">
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <h3 className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</h3>
                      <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? "bg-primary-600 text-background-50" : "bg-background-100 text-foreground-700"}`}>
                        <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-lg`} />
                      </span>
                    </button>
                    <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{f.a}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}